import { createStore } from 'zustand'

import {
  AuctionDetailAuthenticatorOptions,
  AuctionDetailAuthenticatorStore
} from './interface'

export const createAuctionDetailAuthenticatorStore = ({
  ref
}: AuctionDetailAuthenticatorOptions) =>
  createStore<AuctionDetailAuthenticatorStore>((set, get) => ({ ref }))
